var module = angular.module('octopusApp.shared');

module.factory('helpManager', function($rootScope) {
  var manager = {};

  manager.helpBlocks = [];
  manager.isHelpVisible = false;

  manager.toggleHelp = function() {
    manager.isHelpVisible = !manager.isHelpVisible;

    _.each(manager.helpBlocks, function (block) {
      block(manager.isHelpVisible);
    });
  };

  manager.registerHelpElement = function(callback) {
    manager.helpBlocks.push(callback);
  };

  $rootScope.$on('$routeChangeStart', function() {
    manager.helpBlocks = [];
  });

  manager.hasHelp = function() {
    return manager.helpBlocks.length > 0;
  };

  return manager;
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/services/help_manager.js
// module id = 608
// module chunks = 1